export default __webpack_public_path__ + "static/media/tiger_ANGRY.4e0549ad.png";